module.exports = __webpack_public_path__ + "img/milk.2041f366.svg";